import { useCallback } from 'react';
import { analyticsTrackEvent } from '../../../../../core/analytics';
import { ACTION_SEE_SWIMLANE, PROFILE_DISCOVER } from '../../../../../core/analytics/events';

export default (userProfile: any) =>
  useCallback(
    (title, categoryId) => {
      analyticsTrackEvent(PROFILE_DISCOVER, {
        action: ACTION_SEE_SWIMLANE,
        title,
        userProfileId: userProfile.id,
        categoryId,
      });
    },
    [userProfile]
  );
